import React from 'react'
import Carousel from 'react-multi-carousel'
import FortuneBasketCard from '../UI/FortuneBasketCard'

const RelatedProducts = ({ relatedProductsData }) => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      partialVisibilityGutter: 20,
    },
    tablet: {
      breakpoint: { max: 1024, min: 767 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 1,
    },
  }

  return (
    <Carousel
      arrows={false}
      responsive={responsive}
      containerClass="carousel-container related-products-carousel"
      itemClass="related-product-slide pe-md-3 px-1"
      showDots={false}
      infinite={true}
      renderDotsOutside={true}
      partialVisible={true}
      className="ps-0"
    >
      {relatedProductsData.map((item) => (
        <div key={item.product_id} className="related-product-slide__inner">
          <FortuneBasketCard item={item} />
        </div>
      ))}
    </Carousel>
  )
}

export default RelatedProducts
